import React from "react";
import RK_B from "../../../../images/RK_B.png";
import KT_B from "../../../../images/KT_B.png";
import BP_B from "../../../../images/BP_B.png";
import QN_B from "../../../../images/QN_B.png";
import "./promotion.css";

const PromotionBlack = props => {
	return (
		<div className="promotion">
			<div className={props.blackPromotionVisible ? "promotion-visible" : "promotion-hidden"}>
				<div className="promotion-container">
					<h5 className="promotion-title">PROMOTE PIECE TO:</h5>
					<div className="promotion-background">
						<img src={KT_B} alt="KT_B" className="option-black" onClick={() => props.handlePiecePromotion("knight", "black")} />
						<img src={BP_B} alt="BP_B" className="option-black" onClick={() => props.handlePiecePromotion("bishop", "black")} />
						<img src={RK_B} alt="RK_B" className="option-black" onClick={() => props.handlePiecePromotion("rook", "black")} />
						<img src={QN_B} alt="QN_B" className="option-black" onClick={() => props.handlePiecePromotion("queen", "black")} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PromotionBlack;
